<template>
  <div class="profile-selection-view">
    <ProfileSelector />
  </div>
</template>

<script setup lang="ts">
import ProfileSelector from "../components/ProfileSelector.vue";
</script>

<style scoped>
.profile-selection-view {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
